import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Button from '@material-ui/core/Button';

import ConfirmContext from 'contexts/ConfirmContext';

import { useStyles } from './styles';

const ACCOMMODATION_AND_ACTIVITIES_PAGE = '/accommodations-and-activities';
const ACCOMMODATIONS_TAB = 0;
const ACTIVITIES_TAB = 1;

const FormActionButtons = ({
  cancelPath,
  actionLabel,
  isDisabledAction,
  form,
  cancelCallback,
  setSubmitButton,
  integration,
  isUpdate
}) => {
  const classes = useStyles();
  const history = useHistory();
  const confirm = React.useContext(ConfirmContext);
  const [t] = useTranslation();

  const pathName = history.location.pathname;

  let historyState = {};

  if (cancelPath === ACCOMMODATION_AND_ACTIVITIES_PAGE) {
    if (pathName.indexOf('accommodations') >= 0) {
      historyState = {
        state: {
          tabNumber: ACCOMMODATIONS_TAB
        }
      };
    } else if (pathName.indexOf('activities') >= 0) {
      historyState = {
        state: {
          tabNumber: ACTIVITIES_TAB
        }
      };
    }
  }

  const onCancelHandler = () => {
    confirm({
      title: 'Are you sure you want to cancel?',
      confirmationText: 'Cancel',
      cancellationText: 'Back'
    })
      .then(() => {
        if (pathName === cancelPath && cancelCallback) {
          cancelCallback();
          return;
        }
        history.push({
          pathname: cancelPath,
          ...historyState
        });
      })
      .catch(() => {});
  };

  return (
    <div className={classes.wrapper}>
      <Button
        variant="outlined"
        onClick={onCancelHandler}
        classes={{
          root: classes.cancelBtnRoot
        }}
      >
        {t('Cancel')}
      </Button>
      {!integration && isUpdate && (
        <Button
          type="submit"
          variant="contained"
          className={classes.saveButton}
          classes={{
            root: classes.actionBtnRoot,
            disabled: classes.actionBtnDisabled
          }}
          onClick={() => setSubmitButton && setSubmitButton('save')}
        >
          {t('Save')}
        </Button>
      )}
      <Button
        type="submit"
        variant="contained"
        disabled={isDisabledAction}
        classes={{
          root: classes.actionBtnRoot,
          disabled: classes.actionBtnDisabled
        }}
        form={form}
        onClick={() => setSubmitButton && setSubmitButton('next')}
      >
        {t(actionLabel)}
      </Button>
    </div>
  );
};

export default FormActionButtons;
